import { DeleteOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { IToolkitActionContext } from 'client/components/toolkit/actions/ToolkitActionContext';
import { ToolkitObject } from 'client/components/toolkit/objects/ToolkitObject';
import React from 'react';
import { createToolkitAction } from 'client/components/toolkit/actions/ToolkitAction';
import { set } from 'client/core/data/set';
import { DocumentToolkitObject } from 'client/components/widget-repository/objects/documents/DocumentToolkitObject';
import { WidgetHighlightedDocumentsProfile } from '../WidgetHighlightedDocumentsProfile';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';

export const WidgetActionDeleteHighlightedDocument = createToolkitAction({
  name: 'Rimuovi documento',
  code: 'delete-highlighted-document',
  icon: <DeleteOutlined />,
  arguments: [
    {
      type: [DocumentToolkitObject],
      name: 'Documento'
    }
  ],
  async execute(ctx: IToolkitActionContext, documentObject: ToolkitObject) {
    const document = DocumentToolkitObject.get(documentObject)!;

    onConfirm(ctx, {}, document);
  }
});

async function onConfirm(
  ctx: IToolkitActionContext,
  values: any,
  document: ToolkitObject
) {
  try {
    const widget = ctx.deskContext.widgets.find(
      w => w.id === document.sourceWidgetId
    );
    const profile = widget?.profile;
    const data = profile?.data as WidgetHighlightedDocumentsProfile | null;

    const deletedDocument = document.data;

    const updatedData = data?.documents.filter(
      d => d.id !== deletedDocument.id
    );

    await ctx.deskContext.updateWidget(
      set(widget!, 'profile.data.documents', [...(updatedData ?? [])])
    );

    message.success('Documento rimosso con successo');
  } catch (e) {
    message.error(
      getNetworkErrorMessage(e, 'Impossibile rimuovere il documento')
    );
    console.error(e);
    return false;
  }
}
